import { parseToItemsWithKeys } from 'utils/parseToItems';

import useTranslation from 'components/fields/BoundarySelectPanelField/hooks/useTranslation';

import useBoundaries from 'hooks/useBoundaries';
import useSelectPanelField from 'hooks/useSelectPanelField';

import { DEFAULT_PAGE_SIZE, FIELD_SECTION_KEY, OTHER_SECTION_KEY } from './constants';
import type { BoundaryResponse, GetSectionKey, PanelSection, Props } from './types';

const useData = ({ siteId }: Props) => {
    const { fetch, isLoading, reset } = useBoundaries();
    const { FIELD_BOUNDARIES, NO_BOUNDARIES_FOUND, OTHER_BOUNDARIES } = useTranslation();

    const fetchWithSiteId = (args?: { name?: string; pageSize?: number }) =>
        fetch({
            includeUnassigned: true,
            name: args?.name,
            pageSize: args?.pageSize,
            siteId
        });

    const { handleAsyncFilter, hasNextPage, items, noItemsText, onNextPage } =
        useSelectPanelField<BoundaryResponse>({
            dependency: siteId,
            fetchFn: fetchWithSiteId,
            noItemsFoundText: NO_BOUNDARIES_FOUND,
            pageSize: DEFAULT_PAGE_SIZE,
            parseFn: boundaries => parseToItemsWithKeys(boundaries, ['siteId']),
            resetFn: reset
        });

    const getSectionKey: GetSectionKey = item =>
        'siteId' in item && item.siteId ? FIELD_SECTION_KEY : OTHER_SECTION_KEY;

    const sections: PanelSection[] | undefined = siteId
        ? [
              { key: FIELD_SECTION_KEY, labelText: FIELD_BOUNDARIES },
              { key: OTHER_SECTION_KEY, labelText: OTHER_BOUNDARIES }
          ]
        : undefined;

    return {
        boundaryItems: items,
        getSectionKey,
        handleAsyncFilter,
        hasNextPage,
        isLoading,
        noItemsText,
        onNextPage,
        sections
    };
};

export default useData;
